import { IMAGES } from "../../constants/images";

// Hero Section with SEO H1 - Mobile Optimized
const HeroSection = () => {
  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${IMAGES.hero})` }}
      >
        <div className="hero-overlay absolute inset-0"></div>
      </div>

      {/* Content - Centered with proper spacing */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center pt-24 sm:pt-32">
        <p className="section-subtitle animate-fade-in-up text-xs sm:text-sm tracking-[4px] mb-4" style={{ animationDelay: "0.1s" }}>
          SERVICIO PREMIUM VTC
        </p>
        
        {/* SEO-optimized H1 - Clear spacing */}
        <h1
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-6 sm:mb-8 animate-fade-in-up leading-tight"
          style={{ fontFamily: "'Cinzel', serif", animationDelay: "0.2s", letterSpacing: "0.05em" }}
          data-testid="hero-title"
        >
          <span className="block">Su Experiencia en la</span>
          <span className="gradient-text font-semibold block mt-2">Costa del Sol</span>
        </h1>
        
        {/* Description with better spacing */}
        <p
          className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-10 sm:mb-12 animate-fade-in-up leading-relaxed px-4"
          style={{ animationDelay: "0.3s" }}
          data-testid="hero-description"
        >
          Traslados de lujo al aeropuerto de Málaga, servicios por horas y tours exclusivos 
          por Marbella y Puerto Banús. Vehículos Mercedes premium.
        </p>

        {/* CTA Buttons */}
        <div
          className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center animate-fade-in-up px-4 sm:px-0 mb-12 sm:mb-16"
          style={{ animationDelay: "0.4s" }}
        >
          <a href="#reservar" className="btn-primary w-full sm:w-auto text-center px-10" data-testid="hero-reserve-btn">
            Reservar Ahora
          </a>
          <a href="#flota" className="btn-secondary w-full sm:w-auto text-center px-10" data-testid="hero-fleet-btn">
            Ver Flota
          </a>
        </div>

        {/* Trust Badges */}
        <div
          className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 animate-fade-in-up px-2 sm:px-0"
          style={{ animationDelay: "0.5s" }}
        >
          {[
            { icon: "fa-id-card", label: "Licencia VTC", value: "100% Legal" },
            { icon: "fa-star", label: "5 Estrellas", value: "+500 Viajes" },
            { icon: "fa-user-tie", label: "Conductores", value: "Certificados" },
            { icon: "fa-calendar-check", label: "Reserva Online", value: "24/7" }
          ].map((badge, idx) => (
            <div key={idx} className="glass rounded-lg p-4 sm:p-5" data-testid={`trust-badge-${idx}`}>
              <i className={`fas ${badge.icon} text-[#c9a962] text-xl sm:text-2xl mb-2`}></i>
              <p className="text-[10px] sm:text-xs text-gray-400 uppercase tracking-wider">{badge.label}</p>
              <p className="text-sm sm:text-base font-semibold text-white">{badge.value}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="fas fa-chevron-down text-[#c9a962] text-2xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
